import { useQuery } from "@tanstack/react-query";
import { fetchAvailableServices } from "@/lib/services/appointmentModalService";

/**
 * React Query hook to fetch available services for a given company and master.
 * Returns { data, isLoading, error }.
 */
export function useAvailableServices(masterId: number | undefined) {
  return useQuery({
    queryKey: ["availableServices",masterId],
    queryFn: () =>
      masterId
        ? fetchAvailableServices(masterId)
        : Promise.resolve([]),
    enabled: !!masterId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
